let timelineElements = [
  {
    id: 0,
    title: "ANZ | Software Developer | Node.js, React, AWS, Kubernetes, Code fresh CI/CD, Fastify, MQ",
    location: "Bangalore",
    description:
      "• Developed and contributed to a microservices-based mediation platform with multi-cloud support (AWS, GCP) and on-prem environments, supporting 1000+ services, delivering high scalability, reliability, and optimized performance across distributed systems. • Integrated MQ support by developing a Java-based adapter, enhancing message handling and reliability within the mediation layer. • Created an NPM package mu2-tokenisation leveraging ANZ’s Advanced Data Protection (ADP) for secure PII tokenization and masking. • Developed a self-service onboarding dashboard (React + Node.js) that auto-generates service templates, triggers, and certificates — reducing onboarding time to under 12 minutes. • Implemented cost optimization strategies, cutting cloud expenditure by up to 80%, and conducted system performance testing to validate scalability. • Enabled one-click deployment and decommissioning through Codefresh CI/CD pipelines, improving operational efficiency, reducing cloud costs, and accelerating release speed. • Automated certificate lifecycle management with a CI/CD-integrated ServiceNow pipeline, ensuring compliance and uptime. • Integrated security and quality tools including Checkmarx, BlackDuck, Twistlock, and SonarQube, ensuring a secure and vulnerability-free platform. • Built an intuitive API Management Application UI using Angular, enabling seamless discovery and management of internal APIs across the organization. • Currently contributing to MQ service enhancements and OS patching automation, focusing on reliability and system performance optimization.",
    buttonText: "View Frontend Projects",
    date: "Oct 2024 - Present",
    icon: "work",
  },
  {
    id: 1,
    title: "FIDELITY INVESTMENTS | SDE APPRENTICESHIP",
    location: "Bangalore",
    description:
      "• Successfully developed and implemented POC for identifying PII data in databases using Angular and Flask. • Developed a data masking tool using Angular 17 SSR, designed with Figma, and unit tested with Jasmine. • Created a Platform Engineering Tool to enable testing teams to spin up databases with production-like data in non-production environments, utilizing Angular, Spring Boot, Jenkins Core, Docker and AWS. • Developed an on-demand resource creation tool using Angular, Jenkins Core, REST APIs and AWS.",
    buttonText: "View Backend Projects",
    date: "Oct 2023 - Sept 2024",
    icon: "",
  },
  {
    id: 2,
    title: "FYLE | Frontend Developer",
    location: "Bangalore",
    description:
      "• Resolved a critical P1 bug in production, ensuring smooth system operation and optimized statement upload speed by 5%. • Led the migration from AngularJS to Angular, improving scalability and modernization. Utilized Tailwind and SCSS for styling, and Jasmine and Karma for unit testing.",
    buttonText: "View Frontend Projects",
    date: "May 2023 - Aug 2023",
    icon: "work",
  },
  {
    id: 3,
    title: "PALO ALTO | Cyber Security Virtual Internship",
    location: "Bangalore",
    description:
      "• Researched and analysed computer network fundamentals, including OSI model, TCP/IP, Ethernet, Wi-Fi, and WANs, to optimize connectivity and enhance data transfer efficiency.",
    buttonText: "Company Website",
    date: "Sept 2011 - June 2013",
    icon: "",
  },
];

export default timelineElements;
